/**
 * English locale
 */
export default {
  common: {
    tip: 'Tip',
    ok: 'OK',
    cancel: 'Cancel',
    send: 'Send',
    confirm: 'Confirm',
    search: 'Search',
    delete: 'Delete',
    save: 'Save',
    submit: 'Submit',
    loading: 'Loading...',
    more: 'More',
    close: 'Close',
    noData: 'No data',
    verify: 'Verify',
    me: 'Me',
    remove: 'Remove',
    back: 'Back',
    resizeWidth: 'Drag to resize width',
    minimize: 'Minimize',
    fullscreen: 'Fullscreen',
    restore: 'Restore',
    uploading: 'Uploading...',
    fileFormatError: 'Invalid file format. Please upload: {formats}',
    fileSizeExceed: 'File size must not exceed {size}!',
    reachedBottom: 'Reached the bottom'
  },
  login: {
    welcome: 'Welcome back',
    welcomeSubtitle: 'Sign in to your account and start your chat journey',
    userName: 'Username',
    userNamePlaceholder: 'Username/Phone/Email',
    password: 'Password',
    login: 'Login',
    logging: 'Logging in...',
    qrLogin: 'Scan to Login',
    noAccount: 'No account? Sign up',
    forgotPwd: 'Forgot password?',
    autoLogin: 'Auto login next time',
    loginSuccess: 'Login successful',
    inputUsername: 'Please enter username',
    inputPassword: 'Please enter password'
  },
  register: {
    subtitle: 'Create your account and start your chat journey',
    phoneRegister: 'Sign up with phone',
    emailRegister: 'Sign up with email',
    usernameRegister: 'Sign up with username',
    phone: 'Phone number',
    smsCode: 'SMS code',
    email: 'Email',
    emailCode: 'Email code',
    userName: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm password',
    register: 'Register & Sign In',
    hasAccount: 'Have an account? Login',
    otherMode: 'Other options',
    getCode: 'Get code',
    resendAfter: 'Resend in {n}s',
    inputPhone: 'Please enter phone number',
    phoneFormatError: 'Invalid phone format',
    inputEmail: 'Please enter email',
    emailFormatError: 'Invalid email format',
    inputCode: 'Please enter verification code',
    inputUserName: 'Please enter username',
    inputPassword: 'Please enter password',
    inputConfirmPassword: 'Please enter password again',
    passwordMismatch: 'Passwords do not match',
    smsSent: 'Verification code sent to your phone',
    emailSent: 'Verification code sent to your email',
    registerSuccess: 'Registration successful, welcome to {name}!'
  },
  resetPwd: {
    title: 'Reset password',
    wizardTitle: 'Password Reset Wizard',
    wizardDesc: 'Reset your password in four easy steps',
    step1: 'Select method',
    step2: 'Verify identity',
    step3: 'Set password',
    step4: 'Complete',
    selectMode: 'Select password reset method',
    phoneReset: 'Reset by phone',
    phoneResetDesc: 'Verify identity via SMS code',
    emailReset: 'Reset by email',
    emailResetDesc: 'Verify identity via email code',
    cancel: 'Cancel',
    next: 'Next',
    prev: 'Previous',
    verify: 'Verify',
    verifyIdentity: 'Verify your identity',
    phone: 'Phone number',
    email: 'Email',
    smsCode: 'SMS code',
    emailCode: 'Email code',
    inputPhone: 'Enter your phone number',
    inputSmsCode: 'Enter SMS verification code',
    inputEmail: 'Enter your email address',
    inputEmailCode: 'Enter 6-digit email code',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    inputNewPassword: 'Enter your new password',
    inputConfirmPassword: 'Enter your new password again',
    reset: 'Reset',
    getCode: 'Get code',
    resendAfter: 'Resend in {n}s',
    submit: 'Submit',
    successTitle: 'Password reset successful!',
    successDesc: 'Your password has been reset. Please log in with your new password.',
    redirectIn: 'Redirecting to login in {n} seconds',
    toLogin: 'Log in now',
    cancelConfirm: 'Cancel password reset?',
    inputCorrectPhone: 'Please enter a valid phone number',
    inputCorrectEmail: 'Please enter a valid email address',
    verifyFail: 'Verification failed, please re-enter the code',
    passwordMismatch: 'Passwords do not match',
    resetSuccess: 'Password reset successful!'
  },
  setting: {
    personalInfo: 'Profile',
    userConfig: 'Settings',
    bindPhone: 'Bind phone',
    bindEmail: 'Bind email',
    modifyPassword: 'Change password',
    realnameAuth: 'Real-name verification',
    aboutUs: 'About',
    language: 'Language',
    languageDesc: 'Switch interface language',
    myFavorite: 'My Favorites'
  },
  bindPhone: {
    successTitle: 'Phone bound successfully',
    successDesc: 'Your phone {phone} has been bound',
    tipTitle: 'Bind phone number',
    tipDesc: 'Binding a phone number allows you to reset password quickly and improves account security',
    formTitle: 'Bind phone',
    inputPhone: 'Enter phone number',
    inputCode: 'Enter verification code',
    resendAfter: 'Resend in {n}s',
    bind: 'Bind',
    confirmBind: 'Phone cannot be changed after binding. Continue?',
    bindSuccess: 'Phone bound successfully',
    sendCodeFail: 'Failed to send code',
    inputPhoneError: 'Please enter phone number',
    phoneFormatError: 'Invalid phone format',
    inputCodeError: 'Please enter verification code'
  },
  bindEmail: {
    successTitle: 'Email bound successfully',
    successDesc: 'Your email {email} has been bound',
    tipTitle: 'Bind email',
    tipDesc: 'Binding email allows you to reset password quickly and improves account security',
    formTitle: 'Bind email',
    inputEmail: 'Enter email address',
    inputCode: 'Enter verification code',
    resendAfter: 'Resend in {n}s',
    bind: 'Bind',
    confirmBind: 'Email cannot be changed after binding. Continue?',
    bindSuccess: 'Email bound successfully',
    sendCodeFail: 'Failed to send code',
    inputEmailError: 'Please enter email',
    emailFormatError: 'Invalid email format',
    inputCodeError: 'Please enter verification code'
  },
  qrLogin: {
    title: 'Scan to Login',
    subtitle: 'Scan QR code with mobile app to login',
    generating: 'Generating QR code...',
    scanTip: 'Scan QR code with mobile app',
    expireTip: 'QR code expires in {n} seconds',
    scannedTip: 'Scanned, please confirm on your phone',
    loginSuccess: 'Login successful!',
    expired: 'QR code expired',
    refresh: 'Refresh',
    ensureAppLoggedIn: 'Please ensure the mobile app is logged in',
    generateFailed: 'Failed to generate QR code'
  },
  personalInfo: {
    changeAvatar: 'Change avatar',
    noNickname: 'No nickname set',
    basicInfo: 'Basic info',
    company: 'Company',
    nickname: 'Nickname',
    inputNickname: 'Enter nickname',
    sex: 'Gender',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    noBindPhone: 'Phone not bound',
    noBindEmail: 'Email not bound',
    goBind: 'Bind',
    signature: 'Signature',
    signaturePlaceholder: 'Share your thoughts...',
    submit: 'Submit',
    modifySuccess: 'Updated successfully',
    sexNotSet: 'Not set',
    noSignatureTitle: 'No signature yet',
    noSignatureDesc: 'Edit your signature in profile settings',
    online: 'online',
    userOnline: 'User is online'
  },
  realnameAuth: {
    successTitle: 'Verification successful',
    successDesc: 'Your real-name verification has been approved',
    realName: 'Real name',
    idCardNumber: 'ID number',
    authTime: 'Verified at',
    pendingTitle: 'Under review',
    pendingDesc: 'Your application is under review. Please wait.',
    resubmit: 'Resubmit',
    failTitle: 'Verification failed',
    failReason: 'Reason',
    failDesc: 'Your application was not approved. Please resubmit.',
    tipTitle: 'Real-name verification',
    tipDesc: 'Verification improves account security. Please ensure ID photos are clear and information is accurate.',
    resubmitTip: 'Resubmitting will overwrite previous information',
    formTitle: 'Real-name verification',
    inputRealName: 'Enter real name',
    inputIdCard: 'Enter ID number',
    idCardFront: 'ID front',
    idCardBack: 'ID back',
    uploadFront: 'Upload ID front',
    uploadBack: 'Upload ID back',
    uploadFrontTip: 'Upload a clear photo of ID front',
    uploadBackTip: 'Upload a clear photo of ID back',
    submitAuth: 'Submit',
    submitSuccess: 'Application submitted. Please wait for review.',
    confirmSubmit: 'Information cannot be changed after approval. Confirm submit?',
    inputRealNameError: 'Please enter real name',
    nameLengthError: 'Name must be 2-20 characters',
    inputIdCardError: 'Please enter ID number',
    idCardFormatError: 'Invalid ID number format',
    uploadFrontError: 'Please upload ID front photo',
    uploadBackError: 'Please upload ID back photo'
  },
  captcha: {
    codeError: 'Invalid verification code'
  },
  modifyPassword: {
    title: 'Change password',
    oldPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    submit: 'Submit',
    inputPassword: 'Please enter password',
    passwordMismatch: 'Passwords do not match',
    success: 'Password changed successfully'
  },
  userConfig: {
    privacy: 'Privacy',
    manualApprove: 'Require verification when adding me as friend',
    notification: 'Notifications',
    audioTip: 'Message sound'
  },
  aboutUs: {
    appInfo: 'App info',
    currentVersion: 'Current version',
    latestVersion: 'Latest version',
    updateCheck: 'Update',
    checkUpdate: 'Check for updates',
    checking: 'Checking...',
    updateNow: 'Update now',
    autoUpdate: 'Auto update',
    unknown: 'Unknown',
    latestVersionTip: 'Already latest version',
    downloadComplete: 'Update downloaded, ready to install',
    devNoUpdate: 'Update check not available in dev mode',
    cannotConnect: 'Cannot connect to update server',
    downloading: 'Downloading update...',
    updateFailed: 'Update failed',
    installConfirm: 'App will restart after update. Continue?',
    installConfirmTitle: 'Confirm install',
    installNow: 'Install now',
    installUpdate: 'Install and restart',
    installUpdateLabel: 'Install update',
    installing: 'Installing, app will restart...',
    updateAvailable: 'New version {version} available. Update now?',
    updateCheckFailed: 'Update check failed: {error}',
    downloadUpdateFailed: 'Download update failed: {error}',
    updateFailedWith: 'Update failed: {error}',
    installFailed: 'Install failed: {error}'
  },
  home: {
    logout: 'Logout',
    forceLogout: 'You have been logged in elsewhere and will be forced offline',
    forceLogoutTitle: 'Force logout',
    systemNotify: 'System notification',
    unknownUser: 'Unknown user',
    unknownGroup: 'Unknown group',
    accountBanned: 'Your account has been banned',
    accountCancelled: 'Your account has been cancelled',
    initFailed: 'Initialization failed',
    reconnectSuccess: 'Reconnected successfully',
    reconnecting: 'Connection lost, reconnecting...',
    accountBannedTitle: 'Account banned',
    accountBannedReason: 'Your account has been banned. Reason: {reason}',
    pullMsgFailed: 'Failed to pull offline messages',
    nUnreadTitle: '{n} unread'
  },
  chat: {
    search: 'Search',
    checkedContactsCount: 'Selected {n} contact(s)',
    recentChats: 'Recent chats',
    friendsTab: 'Friends',
    groupsTab: 'Groups',
    initializing: "Initializing...",
    receivingMsg: 'Receiving messages...',
    deleteChat: 'Chat history will be cleared. Delete chat with \'{name}\'?',
    deleteChatTitle: 'Delete chat',
    notInGroup: 'You are no longer in this group',
    chatPlaceholder: 'Say something...',
    receiptMessage: '[Receipt message]',
    groupInfo: 'Group info',
    groupShort: 'Group',
    topShort: 'Top',
    official: 'Official',
    selectedCount: '{n}/20',
    maxLimit: 'Limit reached',
    forwardOneByOne: 'Forward one by one',
    mergeForward: 'Merge and forward',
    atMe: 'Someone @ me',
    atMeTag: '[Someone @ me]',
    atAll: '[@All]',
    atHim: 'Mention',
    allMembers: 'All',
    draft: '[Draft]',
    untop: 'Remove from top',
    notifyOn: 'Enable notifications',
    deleteChatItem: 'Delete chat',
    newMessages: '{n} new messages',
    backToBottom: 'Back to bottom',
    emoji: 'Emoji',
    sendImage: 'Send image',
    newMessageCount: '{n} messages',
    inputRemark: 'Enter remark',
    clickSetRemark: 'Click to set remark',
    receiptMsg: 'Receipt message',
    sendVideo: 'Send video',
    sendFile: 'Send file',
    sendVoice: 'Send voice',
    voiceCall: 'Voice call',
    videoCall: 'Video call',
    groupCall: 'Group call',
    chatHistory: 'Chat history',
    searchChatHistory: 'Search chat history',
    allTab: 'All',
    textTab: 'Text',
    imageTab: 'Images',
    stickerTab: 'Stickers',
    fileTab: 'Files',
    voiceTab: 'Voice',
    videoTab: 'Video',
    uploadedAt: 'Uploaded at',
    locateInChat: 'Locate in chat',
    noSearchResultInHistory: 'No results for \'{text}\'',
    forwardMsg: 'Forward message',
    inputPlaceholder: 'Enter message (Ctrl+Enter for new line)',
    copyUserId: 'Copy user ID',
    dndOn: 'Do not disturb enabled',
    dndOff: 'Do not disturb disabled',
    topOn: 'Sticky chat on top',
    topOff: 'Remove chat from top',
    opFailed: 'Operation failed, please try again',
    addBlacklist: 'Add to blacklist',
    addBlacklistConfirm: 'You will no longer receive messages. Add \'{name}\' to blacklist?',
    addedBlacklist: '\'{name}\' added to blacklist',
    removedBlacklist: '\'{name}\' removed from blacklist',
    clearChatConfirm: 'Clear all chat history with \'{name}\'?',
    clearChatTitle: 'Clear chat history',
    clearedChat: 'Cleared chat history with \'{name}\'',
    remarkSuccess: 'Remark set successfully',
    remarkCleared: 'Remark cleared',
    dndLabel: 'Do not disturb',
    topLabel: 'Sticky on top',
    blacklistLabel: 'Add to blacklist',
    complaintUser: 'Harassed? Report this user',
    copySuccess: '\'{content}\' copied to clipboard',
    copyFailed: 'Copy failed',
    recallCall: 'Call again',
    sending: 'Sending',
    sendFail: 'Send failed',
    allRead: 'All read',
    you: 'You',
    other: 'The other',
    copy: 'Copy',
    addToSticker: 'Add to stickers',
    multiSelect: 'Multi-select',
    recall: 'Recall',
    recallConfirm: 'Recall this message?',
    recallTitle: 'Recall message',
    recallMsgSuccess: 'Message recalled',
    forwardSuccess: 'Forwarded successfully',
    forwardSuccessToChats: 'Forwarded {n} messages to {m} chats',
    forwardPartialFail: 'Forwarded {success}/{total} messages, some failed',
    mergeForwardSuccessToChats: 'Merge forwarded {n} messages to {m} chats',
    mergeForwardPartialFail: 'Forwarded to {success}/{total} chats, some failed',
    locateFail: 'Cannot locate original message',
    quote: 'Quote',
    forward: 'Forward',
    top: 'Sticky on top',
    download: 'Download',
    favorite: 'Favorite',
    favoriteSuccess: 'Favorited',
    locateQuote: 'Locate original',
    recallContent: '{name} recalled a message',
    quoteRecalled: 'Quoted content recalled',
    maxSelect20: 'Maximum 20 messages',
    notFriendCall: 'Cannot call, no longer friends',
    inCall: 'Already in a call',
    copySuccess2: 'Copied to clipboard',
    resendNotSupport: 'This message cannot be resent automatically',
    deleteMsgConfirm: 'Delete message?',
    deleteMsgTitle: 'Delete message',
    addStickerSuccess: 'Added to custom stickers',
    selectToDelete: 'Please select messages to delete',
    batchDeleteConfirm: 'Delete {n} selected messages?',
    batchDeleteTitle: 'Batch delete',
    deleteSuccess: 'Deleted',
    selectToForward: 'Please select messages to forward',
    forwardTip: 'Card, call and failed messages cannot be forwarded. Continue?',
    continueSend: 'Continue',
    noForwardMsg: 'No messages to forward',
    mergeForwardMin2: 'Merge forward requires at least 2 messages',
    unsentForwardTip: '{n} unsent messages cannot be forwarded. Continue with others?',
    groupChatHistory: 'Chat history of \'{name}\'',
    privateChatHistory: 'Chat history of \'{name1}\' and \'{name2}\'',
    read: 'read',
    unread: 'unread',
    nRead: '{n} read',
    unsupportedType: '[Unsupported message type]',
    previewImage: '[Image]',
    previewVideo: '[Video]',
    previewFile: '[File]',
    previewVoice: '[Voice]',
    previewUserCard: '[Personal card]',
    previewGroupCard: '[Group card]',
    previewSticker: '[Sticker]',
    userCard: 'Personal card',
    groupCard: 'Group card',
    mergeForwardCount: '[Merge forward] {n} messages',
    viewDetail: 'Show details',
    topMessageLabel: 'TOP: ',
    removeTopConfirm: 'Remove this message from top for all members?',
    removeTopTitle: 'Remove top message',
    voiceCallTag: '[Voice call]',
    videoCallTag: '[Video call]',
    screenshotHideWindow: 'Hide window when screenshot',
    screenshotShortcut: 'Screenshot (CTRL + ALT + A)',
    readStatus: 'Read status',
    readTab: 'Read',
    unreadTab: 'Unread',
    noReadMembers: 'No read members',
    noUnreadMembers: 'No unread members',
    cardExpiredWarning: 'This card has expired'
  },
  emotion: {
    searchPlaceholder: 'Search by name',
    searching: 'Searching...',
    noSearchResult: 'No stickers found',
    searchHint: 'Enter sticker name to search',
    noCustomSticker: 'No custom stickers. Click the button above to add',
    loading: 'Loading...',
    noSticker: 'No stickers',
    searchEmoji: 'Search',
    defaultEmoji: 'Default',
    myEmoji: 'My stickers',
    topSuccess: 'Sticky on top success',
    topFail: 'Sticky on top success',
    deleteStickerConfirm: 'Delete this custom sticker?',
    deleteStickerTitle: 'Delete sticker',
    deleteSuccess: 'Deleted',
    addSuccess: 'Added'
  },
  friend: {
    newFriend: 'New friends',
    addFriend: 'Add friend',
    applyTitle: 'Add friend request',
    applyTip: 'Tip: Friend verification is enabled. You will become friends after they accept.',
    defaultRemark: 'I am {name}',
    addSuccess: '\'{name}\' is now your friend',
    applySent: 'Friend request sent to \'{name}\'',
    searchPlaceholder: 'ID/Nickname/Phone/Email, up to 20 results',
    noSearchResult: 'No users found for \'{text}\'',
    phone: 'Phone',
    email: 'Email',
    waitingApprove: 'Waiting for approval',
    addAsFriend: 'Add friend',
    recvRequests: 'Received',
    sendRequests: 'Sent',
    requestAddOther: 'Request to add as friend',
    requestAddYou: 'Request to add you as friend',
    reject: 'Reject',
    approve: 'Accept',
    recall: 'Recall',
    approveSuccess: '{name} is now your friend',
    rejectSuccess: 'You rejected {name}\'s friend request',
    recallSuccess: 'You recalled the friend request to {name}',
    usernameId: 'Username (ID)',
    cancelled: 'Cancelled',
    nickname: 'Nickname',
    company: 'Company',
    remark: 'Remark',
    noRemark: 'No remark set',
    sendMessage: 'Send message',
    sendCard: 'Send card',
    sex: 'Gender',
    signature: 'Signature',
    noSignature: 'This user hasn\'t left a signature',
    male: 'Male',
    female: 'Female',
    modifyRemark: 'Modify remark',
    inputFriendRemark: 'Enter remark',
    remarkMax32: 'Remark max 32 characters',
    deleteFriend: 'Delete friend',
    confirmRemove: 'Confirm remove?',
    deleteFriendConfirm: 'Delete \'{name}\' and clear chat history?',
    deleteFriendTitle: 'Delete friend',
    deleteFriendSuccess: 'Friend deleted',
    deleteFriendSuccessWithName: 'Deleted friend \'{name}\'',
    sendSuccess: 'Sent',
    online: 'online',
    onlinePc: 'Online on PC',
    onlineMobile: 'Online on mobile',
    tags: 'Tags',
    tag: 'Tag',
    noTag: 'No tags set',
    noTagTip: 'No tags yet, click + to create',
    createTag: 'Create tag',
    renameTag: 'Rename tag',
    deleteTag: 'Delete tag',
    deleteTagConfirm: 'Delete tag \'{name}\'? Friends in the tag will not be affected',
    inputTagName: 'Enter tag name',
    inputNewTag: 'Enter tag name, press Enter to create',
    tagNameMax32: 'Tag name max 32 characters',
    setTag: 'Set tags',
    setTagSuccess: 'Tags saved',
    membersCount: '{n} people',
    tagMemberEmpty: 'No friends in this tag',
    selectTagTip: 'Select a tag on the left to view members',
    addTagMember: 'Add members',
    noSearchResultTip: 'No matching friends found',
  },
  group: {
    join: 'Join',
    create: 'Create group',
    groupInfo: 'Group info',
    members: 'Group members',
    membersCount: '{n} members',
    searchMembers: 'Search group members',
    invite: 'Invite',
    inviteFriend: 'Invite friends to group',
    inviteTitle: 'Invite friends',
    selectMember: 'Select members',
    searchFriends: 'Search friends',
    checkedFriendsCount: 'Selected {n} friend(s)',
    inviteSuccess: 'Invitation sent',
    checkedMembersCount: 'Selected {n} member(s)',
    maxSelectMembers: 'Select at most {n} member(s)',
    remove: 'Remove',
    removeMemberTitle: 'Select members to remove from group',
    mute: 'Mute',
    unmute: 'Unmute',
    owner: 'Owner',
    manager: 'Admin',
    groupName: 'Group name',
    changeAvatar: 'Change avatar',
    viewAllMembers: 'Show all members',
    banned: 'Banned',
    muted: 'Muted',
    cardExpired: 'Expired',
    quit: 'Quit group',
    dissolve: 'Dissolve group',
    sendCard: 'Send card',
    createTitle: 'Create group',
    createSuccess: 'Created',
    inputGroupName: 'Enter group name',
    groupNameMax20: 'Group name max 20 characters',
    remark: 'Remark',
    myNickname: 'My name in group',
    notice: 'Group notice',
    noNotice: 'Not set',
    selectToRemove: 'Select members to remove',
    selectToMute: 'Select members to mute',
    selectToUnmute: 'Select members to unmute',
    dissolveConfirm: 'Dissolve \'{name}\'?',
    dissolveConfirmTitle: 'Confirm dissolve?',
    dissolved: '\'{name}\' dissolved',
    quitConfirm: 'Quit \'{name}\' and clear chat history?',
    quitConfirmTitle: 'Confirm quit?',
    quitSuccess: 'You have left \'{name}\'',
    modifySuccess: 'Updated',
    sendSuccess: 'Sent',
    sendMessage: 'Send message',
    joinSuccess: 'You joined \'{name}\'',
    applyJoin: 'Request to join',
    viewProfile: 'Show profile',
    muteMember: 'Mute',
    unmuteMember: 'Unmute',
    kickMember: 'Remove from group',
    addManager: 'Set as admin',
    removeManager: 'Remove admin',
    muteSuccess: 'You muted \'{name}\'',
    unmuteSuccess: 'You unmuted \'{name}\'',
    kickConfirm: 'Remove \'{name}\' from group?',
    kickConfirmTitle: 'Confirm remove?',
    kickSuccess: '\'{name}\' was removed',
    addManagerSuccess: '\'{name}\' is now admin',
    removeManagerSuccess: '\'{name}\' is no longer admin',
    viewAllMembersCount: 'Show all {n} members',
    allMuted: 'Mute all',
    allowMemberInvite: 'Allow members to invite',
    allowMemberShareCard: 'Allow members to share cards',
    groupNameLabel: 'Group name',
    clickSetGroupName: 'Click to set group name',
    clickSetGroupRemark: 'Click to set remark',
    clickSetNickname: 'Click to set nickname',
    clickSetNotice: 'Click to set notice',
    editNotice: 'Edit notice',
    inputNotice: 'Enter notice',
    clearGroupChatConfirm: 'Clear all chat history of \'{name}\'?',
    clearedGroupChat: 'Cleared chat history of \'{name}\'',
    removedMembers: 'Removed {n} members',
    mutedMembers: 'Muted {n} members',
    unmutedMembers: 'Unmuted {n} members',
    quitConfirmMsg: 'You will not receive group messages after quitting. Confirm?',
    complaintGroup: 'Harassed? Report this group',
    forbidViewMemberProfile: 'Forbid viewing member profiles',
    hideGroupMember: 'Hide group members',
    memberHidden: 'Members hidden',
    inviteMembers: 'Invite members',
    groupId: 'Group ID'
  },
  rtc: {
    micOn: 'Microphone on',
    micOff: 'Microphone off',
    speakerOn: 'Speaker on',
    speakerOff: 'Speaker off',
    cameraOn: 'Camera on',
    cameraOff: 'Camera off',
    shareScreen: 'Share screen',
    cancelShare: 'Stop sharing',
    inviteMember: 'Invite members',
    quitCall: 'End call',
    voiceCall: 'Voice call',
    videoCall: 'Video call',
    video: 'Video',
    voice: 'Voice',
    inCall: 'In call',
    calling: 'Calling',
    waitingAnswer: 'Waiting response...',
    hungUpCallEnd: 'You have hung up, call ended',
    cancelCallEnd: 'Call cancelled, call ended',
    rejectedByPeer: 'The user declined your call',
    callCancelledByPeer: 'The user cancelled the call',
    peerHangup: 'The user has hung up',
    acceptedOnOtherDevice: 'Answered on another device',
    rejectedOnOtherDevice: 'Declined on another device',
    notAnswered: 'You did not answer',
    callCancelled: 'Call cancelled',
    notJoined: 'Did not join',
    quitCallTip: 'Left the call',
    deviceNotSupport: 'Device does not support calling',
    cameraAccessFailed: 'Failed to access camera',
    rtcInitFailed: 'RTC init failed. Possible reasons: 1. Server missing SSL cert 2. Device does not support WebRTC',
    openCameraFailed: 'Failed to open camera',
    openMicFailed: 'Failed to open microphone',
    unknownUser: 'Unknown user',
    inviteToGroupCall: 'Inviting you to a group call',
    otherParticipants: 'Other participants:',
    accept: 'Accept',
    reject: 'Decline',
    joinCallConfirm: 'Join this call?',
    host: 'Host: ',
    nInCall: '{n} in call',
    incoming: 'Incoming...',
    hangup: 'Hang up',
    private: {
      acceptTimeout: 'The user did not answer',
      devNotSupport: 'The user\'s device does not support this call',
    },
    group: {
      acceptTimeout: ' not accepted within the time limit',
      userBusy: ' are busy',
      devNotSupport: ' do not support the call'
    }
  },
  chatRecord: {
    title: 'Voice recording',
    duration: 'Duration',
    notStarted: 'Not started',
    recording: 'Recording...',
    paused: 'Paused',
    ended: 'Recording ended',
    startRecord: 'Start recording',
    pauseRecord: 'Pause recording',
    resumeRecord: 'Resume recording',
    endRecord: 'End recording',
    playRecord: 'Play recording',
    stopPlay: 'Stop playing',
    restartRecord: 'Record again',
    sendNow: 'Send now'
  },
  complaint: {
    report: 'Report',
    title: 'Report',
    target: 'Report target',
    reason: 'Reason',
    images: 'Image evidence',
    content: 'Content',
    inputContent: 'Enter complaint content',
    selectReason: 'Please select reason',
    uploadCount: 'You uploaded {n}',
    maxImages: 'Maximum {n} images',
    successMsg: 'We have received your report and will review it within 3 business days',
    harassment: 'Harassment',
    fraud: 'Suspected fraud',
    badContent: 'Bad content',
    other: 'Other violations'
  },
  http: {
    methodError: 'Invalid HTTP method',
    serverError: 'Server error, please try again later',
    notSupport: 'Server does not support this request'
  },
  date: {
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    yesterday: 'Yesterday'
  },
  electron: {
    newMessage: 'You have new messages',
    showWindow: 'Show window',
    quit: 'Quit'
  },
  tip: {
    group: {
      disband: '{0} disbanded the group',
      quit: '{0} left the group',
      remove: '{0} removed {1} from the group',
      invite: '{0} invited {1} to the group',
      joinByCard: '{0} joined the group via {1}\'s shared card',
      joinByQr: '{0} joined the group via {1}\'s QR code',
      topMessage: '{0} pinned a message',
      mutedAll: '{0} enabled mute all, only owner and admins can speak',
      unmutedAll: '{0} disabled mute all',
      memberMuted: '{0} muted {1}',
      memberUnmuted: '{0} unmuted {1}',
      addManager: '{0} became group admin(s)',
      removeManager: '{0} is no longer admin(s)',
      rtcStart: '{0} started a call',
      rtcEnd: 'Call ended',
      banned: 'Group was banned for \'\'{0}\'\'',
      unbanned: 'Group has been unbanned',
      userBanned: 'Your account was banned for \'\'{0}\'\''
    },
    friend: {
      becameFriend: 'You are now friends, start chatting',
      relationRemoved: 'You are no longer friends'
    },
    recall: {
      self: '{0} recalled a message',
      byOther: '{0} recalled {1}\'s message',
      privateSelf: 'You recalled a message',
      privateOther: 'The other party recalled a message',
      quote: 'Quoted content recalled'
    }
  },
  act: {
    rtc: {
      notConnected: 'Not connected',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      duration: 'Call duration {0}'
    }
  },
  merge: {
    title: {
      chatHistory: 'Chat history',
      groupChatHistory: 'Chat history of \'{0}\'',
      privateChatHistory: 'Chat history of \'{0}\' and \'{1}\''
    }
  },
  favorite: {
    myFavorite: 'My Favorites',
    textShort: 'T',
    imageMsg: 'Image',
    videoMsg: 'Video',
    noMore: 'No more',
    detailTitle: 'Favorite Details',
    collectedAt: 'Collected at ',
    sendToFriend: 'Forward',
    sendSuccess: 'Sent successfully',
    confirmDelete: 'Confirm Delete',
    confirmDeleteContent: 'Are you sure you want to delete this favorite?',
    deleteSuccess: 'Deleted successfully'
  }
}
